import Modal from '../UI/Modal';
import CartItem from './CartItem';
import classes from './Cart.module.css';
import CartContext from '../../store/cart-content';
import Checkout from './Checkout';
import { useContext, useState } from 'react';
import useHttp from '../../hooks/use-http';

const Cart = ({ onClose }) => {
  const { REACT_APP_URL } = process.env;
  const [isCheckout, setIsCheckout] = useState(false);
  const cartContext = useContext(CartContext);
  const totalAmount = `$${cartContext.totalAmount.toFixed(2)}`;
  const hasItems = cartContext.items.length > 0;
  const addHandler = (item) => {
    cartContext.addItem({ ...item, amount: 1 });
  };
  const removeHandler = (id) => {
    cartContext.removeItem(id);
  };
  const orderHandler = () => {
    setIsCheckout(true);
  };

  const { isLoading, error, sendRequest } = useHttp();
  const [didSubmit, setDidSubmit] = useState(false);
  const submitHandler = async (userData) => {
    sendRequest({
      url: `${REACT_APP_URL}/orders.json`,
      method: 'POST',
      body: { user: userData, orderedItems: cartContext.items },
    });
    setDidSubmit(true);
    cartContext.clear();
  };

  const cartItems = (
    <ul className={classes[`cart-items`]}>
      {cartContext.items.map((item) => (
        <CartItem
          key={item.id}
          onRemove={() => removeHandler(item.id)}
          onAdd={() => addHandler(item)}
          amount={item.amount}
          name={item.name}
          price={item.price}
        />
      ))}
    </ul>
  );
  const modalAction = (
    <div className={classes.actions}>
      <button className={classes['button--alt']} onClick={onClose}>
        Close
      </button>
      {hasItems && (
        <button className={classes.button} onClick={orderHandler}>
          Order
        </button>
      )}
    </div>
  );
  const cartModal = (
    <>
      {cartItems}
      <div className={classes.total}>
        <span>Total Amount</span>
        <span>{totalAmount}</span>
      </div>
      {isCheckout && <Checkout onCancel={onClose} onSubmit={submitHandler} />}
      {!isCheckout && modalAction}
    </>
  );
  const loading = <p>sending order data...</p>;
  const submitted = <p>order submitted.</p>;
  // const orderError = <p>order error.</p>;
  if (error) {
    console.log(error); // "Something went wrong!" catch (error)
  }
  return (
    <Modal onClose={onClose}>
      {!isLoading && !didSubmit && cartModal}
      {isLoading && loading}
      {!isLoading && didSubmit && submitted}
      {}
    </Modal>
  );
};

export default Cart;
